// extracted by mini-css-extract-plugin
module.exports = {"title":"title-MPzOb","wrapper":"wrapper-1i61S","button":"button-1NZjX"};